import {
  FETCH_ACCOUNT_MAXES_START,
  FETCH_ACCOUNT_MAXES_FULFILLED,
  FETCH_ACCOUNT_MAXES_REJECTED,
  FETCH_ACCOUNT_GOALS_START,
  FETCH_ACCOUNT_GOALS_FULFILLED,
  FETCH_ACCOUNT_GOALS_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_CALENDARS_START,
  FETCH_CALENDARS_FULFILLED,
  FETCH_CALENDARS_REJECTED,
  FETCH_ATHLETES_START,
  FETCH_ATHLETES_FULFILLED,
  FETCH_ATHLETES_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  CREATE_MAX_EFFORT_START,
  CREATE_MAX_EFFORT_FULFILLED,
  CREATE_MAX_EFFORT_REJECTED,
  SAVE_GOAL_START,
  SAVE_GOAL_FULFILLED,
  SAVE_GOAL_REJECTED,
  DELETE_GOALS_START,
  DELETE_GOALS_FULFILLED,
  DELETE_GOALS_REJECTED,
  FETCH_MAX_HISTORY_START,
  FETCH_MAX_HISTORY_FULFILLED,
  FETCH_MAX_HISTORY_REJECTED,
  FETCH_HISTORY_CURRENT_MAX_START,
  FETCH_HISTORY_CURRENT_MAX_FULFILLED,
  FETCH_HISTORY_CURRENT_MAX_REJECTED,
  SET_MAX_ACTIVE_START,
  SET_MAX_ACTIVE_FULFILLED,
  SET_MAX_ACTIVE_REJECTED,
  ARCHIVE_MAX_START,
  ARCHIVE_MAX_FULFILLED,
  ARCHIVE_MAX_REJECTED,
  SET_MAXES_LOCK_START,
  SET_MAXES_LOCK_FULFILLED,
  SET_MAXES_LOCK_REJECTED,
  RESET_MAXES_START,
  RESET_MAXES_FULFILLED,
  RESET_MAXES_REJECTED,
  BULK_ARCHIVE_MAXES_START,
  BULK_ARCHIVE_MAXES_FULFILLED,
  BULK_ARCHIVE_MAXES_REJECTED,
  SET_MAXES_GOALS_FILTER,
} from './actionTypes';
import USER_FILTER_TYPE from '../constants';

const initialState = {
  isAccountMaxesLoading: false,
  isAccountGoalsLoading: false,
  isGroupsLoading: false,
  isCalendarsLoading: false,
  isAthletesLoading: false,
  isExercisesLoading: false,
  isCreatingMaxEffort: false,
  isSavingGoal: false,
  isDeletingGoals: false,
  isMaxHistoryLoading: false,
  isHistoryCurrentMaxLoading: false,
  isSettingMaxActive: false,
  isArchivingMax: false,
  isUpdatingMaxLock: false,
  isResettingMaxes: false,
  isBulkArchivingMaxes: false,
  // Landing state — everyone sees "All Athletes" already selected.
  activeFilter: {
    filterType: USER_FILTER_TYPE.AllAthletes,
    filterIds: [],
    exerciseId: null,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_MAXES_START: {
      return {
        ...state,
        isAccountMaxesLoading: true,
      };
    }
    case FETCH_ACCOUNT_MAXES_FULFILLED: {
      return {
        ...state,
        isAccountMaxesLoading: false,
      };
    }
    case FETCH_ACCOUNT_MAXES_REJECTED: {
      return {
        ...state,
        isAccountMaxesLoading: false,
      };
    }
    case FETCH_ACCOUNT_GOALS_START: {
      return {
        ...state,
        isAccountGoalsLoading: true,
      };
    }
    case FETCH_ACCOUNT_GOALS_FULFILLED: {
      return {
        ...state,
        isAccountGoalsLoading: false,
      };
    }
    case FETCH_ACCOUNT_GOALS_REJECTED: {
      return {
        ...state,
        isAccountGoalsLoading: false,
      };
    }
    case FETCH_GROUPS_START: {
      return {
        ...state,
        isGroupsLoading: true,
      };
    }
    case FETCH_GROUPS_FULFILLED: {
      return {
        ...state,
        isGroupsLoading: false,
      };
    }
    case FETCH_GROUPS_REJECTED: {
      return {
        ...state,
        isGroupsLoading: false,
      };
    }
    case FETCH_CALENDARS_START: {
      return {
        ...state,
        isCalendarsLoading: true,
      };
    }
    case FETCH_CALENDARS_FULFILLED: {
      return {
        ...state,
        isCalendarsLoading: false,
      };
    }
    case FETCH_CALENDARS_REJECTED: {
      return {
        ...state,
        isCalendarsLoading: false,
      };
    }
    case FETCH_ATHLETES_START: {
      return {
        ...state,
        isAthletesLoading: true,
      };
    }
    case FETCH_ATHLETES_FULFILLED: {
      return {
        ...state,
        isAthletesLoading: false,
      };
    }
    case FETCH_ATHLETES_REJECTED: {
      return {
        ...state,
        isAthletesLoading: false,
      };
    }
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        isExercisesLoading: true,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        isExercisesLoading: false,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        isExercisesLoading: false,
      };
    }
    case CREATE_MAX_EFFORT_START: {
      return {
        ...state,
        isCreatingMaxEffort: true,
      };
    }
    case CREATE_MAX_EFFORT_FULFILLED: {
      return {
        ...state,
        isCreatingMaxEffort: false,
      };
    }
    case CREATE_MAX_EFFORT_REJECTED: {
      return {
        ...state,
        isCreatingMaxEffort: false,
      };
    }
    case SAVE_GOAL_START: {
      return {
        ...state,
        isSavingGoal: true,
      };
    }
    case SAVE_GOAL_FULFILLED: {
      return {
        ...state,
        isSavingGoal: false,
      };
    }
    case SAVE_GOAL_REJECTED: {
      return {
        ...state,
        isSavingGoal: false,
      };
    }
    case DELETE_GOALS_START: {
      return {
        ...state,
        isDeletingGoals: true,
      };
    }
    case DELETE_GOALS_FULFILLED: {
      return {
        ...state,
        isDeletingGoals: false,
      };
    }
    case DELETE_GOALS_REJECTED: {
      return {
        ...state,
        isDeletingGoals: false,
      };
    }
    case FETCH_MAX_HISTORY_START: {
      return {
        ...state,
        isMaxHistoryLoading: true,
      };
    }
    case FETCH_MAX_HISTORY_FULFILLED: {
      return {
        ...state,
        isMaxHistoryLoading: false,
      };
    }
    case FETCH_MAX_HISTORY_REJECTED: {
      return {
        ...state,
        isMaxHistoryLoading: false,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_START: {
      return {
        ...state,
        isHistoryCurrentMaxLoading: true,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_FULFILLED: {
      return {
        ...state,
        isHistoryCurrentMaxLoading: false,
      };
    }
    case FETCH_HISTORY_CURRENT_MAX_REJECTED: {
      return {
        ...state,
        isHistoryCurrentMaxLoading: false,
      };
    }
    case SET_MAX_ACTIVE_START: {
      return {
        ...state,
        isSettingMaxActive: true,
      };
    }
    case SET_MAX_ACTIVE_FULFILLED: {
      return {
        ...state,
        isSettingMaxActive: false,
      };
    }
    case SET_MAX_ACTIVE_REJECTED: {
      return {
        ...state,
        isSettingMaxActive: false,
      };
    }
    case ARCHIVE_MAX_START: {
      return {
        ...state,
        isArchivingMax: true,
      };
    }
    case ARCHIVE_MAX_FULFILLED: {
      return {
        ...state,
        isArchivingMax: false,
      };
    }
    case ARCHIVE_MAX_REJECTED: {
      return {
        ...state,
        isArchivingMax: false,
      };
    }
    case SET_MAXES_LOCK_START: {
      return {
        ...state,
        isUpdatingMaxLock: true,
      };
    }
    case SET_MAXES_LOCK_FULFILLED: {
      return {
        ...state,
        isUpdatingMaxLock: false,
      };
    }
    case SET_MAXES_LOCK_REJECTED: {
      return {
        ...state,
        isUpdatingMaxLock: false,
      };
    }
    case RESET_MAXES_START: {
      return {
        ...state,
        isResettingMaxes: true,
      };
    }
    case RESET_MAXES_FULFILLED: {
      return {
        ...state,
        isResettingMaxes: false,
      };
    }
    case RESET_MAXES_REJECTED: {
      return {
        ...state,
        isResettingMaxes: false,
      };
    }
    case BULK_ARCHIVE_MAXES_START: {
      return {
        ...state,
        isBulkArchivingMaxes: true,
      };
    }
    case BULK_ARCHIVE_MAXES_FULFILLED: {
      return {
        ...state,
        isBulkArchivingMaxes: false,
      };
    }
    case BULK_ARCHIVE_MAXES_REJECTED: {
      return {
        ...state,
        isBulkArchivingMaxes: false,
      };
    }
    case SET_MAXES_GOALS_FILTER: {
      return {
        ...state,
        activeFilter: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
